// Core Domain Search BI Events Extension

import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const CoreDomainSearchBiEventsExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=CoreDomainSearchBiEventsExtension.js.map